import { Stack } from '@mui/material'
import React from 'react'
import PageHeader from '../../components/page-layout/PageHeader'
import EmptyListUi from '../../components/EmptyListUi'

const TeamManagement = () => {
return (
    <Stack gap={2}>
        <PageHeader showBack={true} title={'Team Management'} lead={'Manage your team members, roles, and permissions.'} />
        
        <EmptyListUi text={'No Feature Available yet :/'} />
    </Stack>
)
}

export default TeamManagement